import { render, staticRenderFns } from "./szptDialog.vue?vue&type=template&id=6432a75c&scoped=true&"
import script from "./szptDialog.vue?vue&type=script&lang=js&"
export * from "./szptDialog.vue?vue&type=script&lang=js&"
import style0 from "./szptDialog.vue?vue&type=style&index=0&id=6432a75c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6432a75c",
  null
  
)

export default component.exports